import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installVisibilityTracker, installInteractionTracker } from "./lib/diagnostics";
import { registerServiceWorker } from "./lib/webPush";
import { installWebVitals } from "./lib/webVitals";
import { bindGlobalErrorHandlers } from "./lib/errorLogger";

bindGlobalErrorHandlers();
installWebVitals();

installVisibilityTracker();
installInteractionTracker();

// Register the push service worker (no-op inside Lovable preview/iframe).
registerServiceWorker();

createRoot(document.getElementById("root")!).render(<App />);
